import { stateAbbreviations } from "@/constants/stateAbbreviations.ts";
import { Box, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import FormControl from "@mui/material/FormControl";

export interface StoreLocationData {
    insuredCompany: string;
    address: string;
    city: string;
    state: string;
    zip: string;
    attn: string;
    emailAddress: string;
    faxNumber: string;
}

interface StoreLocationFieldsProps {
    storeLocation: StoreLocationData;
    onStoreLocationChange: (field: string, value: string) => void;
}

const StoreLocationFields: React.FC<StoreLocationFieldsProps> = ({
    storeLocation,
    onStoreLocationChange,
}) => {
    return (
        <Box sx={{ mb: 2 }}>
            <TextField
                label="Insured Company"
                value={storeLocation.insuredCompany}
                onChange={(e) => onStoreLocationChange("insuredCompany", e.target.value)}
                fullWidth
                required
                sx={{
                    mb: 2,
                    "& .MuiInputBase-root": {
                        fontSize: "0.875rem",
                    },
                    "& .MuiInputLabel-root": {
                        fontSize: "0.875rem",
                    },
                }}
            />
            <TextField
                label="Store Address"
                value={storeLocation.address}
                onChange={(e) => onStoreLocationChange("address", e.target.value)}
                fullWidth
                required
                sx={{
                    mb: 2,
                    "& .MuiInputBase-root": {
                        fontSize: "0.875rem",
                    },
                    "& .MuiInputLabel-root": {
                        fontSize: "0.875rem",
                    },
                }}
            />
            <TextField
                label="Attention"
                value={storeLocation.attn}
                onChange={(e) => onStoreLocationChange("attn", e.target.value)}
                fullWidth
                sx={{
                    mb: 2,
                    "& .MuiInputBase-root": {
                        fontSize: "0.875rem",
                    },
                    "& .MuiInputLabel-root": {
                        fontSize: "0.875rem",
                    },
                }}
            />

            <Box sx={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr", gap: 2 }}>
                <TextField
                    label="City"
                    value={storeLocation.city}
                    onChange={(e) => onStoreLocationChange("city", e.target.value)}
                    fullWidth
                    required
                    sx={{
                        "& .MuiInputBase-root": {
                            fontSize: "0.875rem",
                        },
                        "& .MuiInputLabel-root": {
                            fontSize: "0.875rem",
                        },
                    }}
                />
                <FormControl
                    fullWidth
                    required
                    sx={{
                        "& .MuiInputLabel-root": {
                            fontSize: "0.875rem",
                        },
                        "& .MuiSelect-select": {
                            fontSize: "0.875rem",
                        },
                    }}
                >
                    <InputLabel>State</InputLabel>
                    <Select
                        value={storeLocation.state}
                        onChange={(e) => onStoreLocationChange("state", e.target.value)}
                        label="State"
                    >
                        {stateAbbreviations.map((state) => (
                            <MenuItem key={state} value={state}>
                                {state}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <TextField
                    label="Zip Code"
                    value={storeLocation.zip}
                    onChange={(e) => onStoreLocationChange("zip", e.target.value)}
                    fullWidth
                    required
                    sx={{
                        "& .MuiInputBase-root": {
                            fontSize: "0.875rem",
                        },
                        "& .MuiInputLabel-root": {
                            fontSize: "0.875rem",
                        },
                    }}
                />
            </Box>
            <TextField
                label="Email Address"
                value={storeLocation.emailAddress}
                onChange={(e) => onStoreLocationChange("emailAddress", e.target.value)}
                fullWidth
                sx={{
                    mt: 2,
                    mb: 2,
                    "& .MuiInputBase-root": {
                        fontSize: "0.875rem",
                    },
                    "& .MuiInputLabel-root": {
                        fontSize: "0.875rem",
                    },
                }}
            />

            <TextField
                label="Fax Number"
                value={storeLocation.faxNumber}
                onChange={(e) => onStoreLocationChange("faxNumber", e.target.value)}
                fullWidth
                sx={{
                    mb: 2,
                    "& .MuiInputBase-root": {
                        fontSize: "0.875rem",
                    },
                    "& .MuiInputLabel-root": {
                        fontSize: "0.875rem",
                    },
                }}
            />
        </Box>
    );
};

export default StoreLocationFields;
